import { all, fork, takeEvery, call, put, select } from 'redux-saga/effects';
import api from '@api/api';
import * as actions from '@store/actions/commonAction';
import {
  isLocal,
  convertJobData,
  isFunction,
  checkApiSuccess,
  getApiData,
  getApiErrorMessage,
  convertLabelOptions,
} from '@common/utils';
import {
  BOOKMARK_JOB_INFO_LIST,
  NBS_JOB_CLSS_CD,
  LOS_COMMON_CODE_INFO,
} from '@common/constants';
import { format } from 'date-fns';

function* confirmModal({ callback }) {
  callback && callback();
}

function* cancelModal({ callback }) {
  callback && callback();
}

function* showJoinAgreeBottomShadowProc() {}

function* searchJobNDriverInfo({ payload }) {
  const { status, data } = yield call(api.searchCommonCode, {
    params: {
      size: 200,
      page: 1,
      cdKey: payload.cdKey,
    },
    payload: {
      cdDsc: payload.searchData ? payload.searchData : '',
    },
  });

  if (status === 200) {
    if (payload.cdKey === 'JOB_CD') {
      // 직업정보 저장
      yield put({
        type: actions.SEARCH_JOB_INFO_SUCCESS,
        payload: data.pagingResult.list,
      });
    } else {
      // 운전정보 저장
      yield put({
        type: actions.SEARCH_DRIVER_INFO_SUCCESS,
        payload: data.pagingResult.list,
      });
    }
  }
}

// 자주 사용하는 직업정보 조회
function* searchBookMarkJobInfo() {
  // Robin: 자주 사용하는 직업 정보 조회 API 가 없어서 직업정보 하드코딩 값 사용
  yield put({
    type: actions.SEARCH_BOOKMARK_JOB_INFO_SUCCESS,
    payload: convertJobData(BOOKMARK_JOB_INFO_LIST),
  });

  // const { status, data } = yield call(api.searchBookMarkJobInfo);
  // if (status === 200) {
  //   console.log('searchBookMarkJobInfo: ', data);
  //   yield put({
  //     type: actions.SEARCH_BOOKMARK_JOB_INFO_SUCCESS,
  //     payload: data,
  //   });
  // }
}

// 직업정보 검색
function* searchJobInfo({ payload }) {
  const searchText = payload.searchData;
  // 직업 정보 검색 Tobe로 수정
  const { status, data: tobeData } = yield call(api.searchJobInfo, {
    payload: {
      data: {
        // "jobRtrvDiv": "1",
        jobRtrvNm: searchText,
        // jobCd: jobCode,
        jobClssCd: NBS_JOB_CLSS_CD,
        appltDd: format(new Date(), 'yyyyMMdd'),
      },
      // cdKey: payload.cdKey,
      // keyword: searchText,
    },
  });

  // 직업검색 Tobe 데이터를 기존 Asis 데이터 형태로 변경
  const jobData = $utils.getApiData(tobeData);
  const data = convertJobData(jobData);
  // const { status, data } = yield call(api.searchDiseaseInfo, {
  //   payload: {
  //     cdKey: payload.cdKey,
  //     keyword: searchText,
  //   },
  // });

  if (status === 200) {
    /* @NOTE: [Robin] 직업정보 검색어가 포함 된 순으로 정렬 [개선 요청 사항 반영] */
    const jobList = data.sort(({ cdDsc }) =>
      !cdDsc.includes(searchText) ? 1 : -1,
    );

    yield put({
      type: actions.SEARCH_JOB_INFO_SUCCESS,
      payload: jobList,
    });
  }
}

// 법인 일반 /전문금융 소비자 여부 등록 및 수정
function* saveFinanceCustomerInfo({ payload }) {
  const { status } = yield call(api.saveFinanceCustomerInfo, {
    params: {
      custNo: payload.custNo,
    },
    payload: {
      specialFinanceCustTypeCode: payload.specialFinanceCustTypeCode,
      generalFinanceCustomerYN: payload.generalFinanceCustomerYN,
    },
  });

  if (status === 200) {
    if (payload.callback)
      payload.callback({
        specialFinanceCustTypeCode: payload.specialFinanceCustTypeCode,
        generalFinanceCustomerYN: payload.generalFinanceCustomerYN,
      });
  }
}

function* getEduGASms() {
  yield call(api.getEduGASms);
}

function* setCodeInfo({ payload }) {
  const { type, ...rest } = payload;
  const { data, status } = yield call(api.getCommonCodeDtlList, {
    payload: { ...rest, rowSize: 9999 },
  });

  if (status === 200) {
    const codes = data?.RSLT_DATA?.pagingResult?.list;
    yield put({
      type: actions.SET_CODE_INFO,
      payload: { type, codes },
    });
  }
}

// 채널기준 본부조회
function* getHqListByChannel({ payload }) {
  const { status, data } = yield call(api.getHqListByChannel, {
    payload: {
      chnlCd: payload.chnlCd,
    },
  });

  if (status === 200) {
    yield put({
      type: actions.GET_HQ_LIST_BY_CHANNEL_SUCCESS,
      payload: data,
    });
  }
}

// 본부기준 지점조회
function* getAgencyListByHq({ payload }) {
  const { status, data } = yield call(api.getAgencyListByHq, {
    payload: {
      chnlCd: payload.chnlCd,
      hqCd: payload.hqCd,
      agncCd: payload.agncCd,
    },
  });

  if (status === 200) {
    yield put({
      type: actions.GET_AGENCY_LIST_BY_HQ_SUCCESS,
      payload: data,
    });
  }
}

// 화면 에러 서버에 저장
function* createErrLog({ payload }) {
  try {
    if (!isLocal) {
      const state = yield select(state => state);
      const { location } = state.router;
      const { userInfo, channelInfo, deviceInfo } = state.userReducer;
      const { customerInfo } = state.customerReducer;

      const deviceId = deviceInfo?.native?.deviceId || deviceInfo?.deviceId;
      const deviceName =
        deviceInfo?.native?.deviceName || deviceInfo?.deviceName;
      const appVersion =
        deviceInfo?.native?.appVersion ||
        JSON.stringify(deviceInfo?.appVersion || '');

      // 서버에 저장할 데이터 설정
      const agentNumber = userInfo?.userId || '';
      const clientId = customerInfo?.clientId || '';
      const errDescription = [
        'T',
        location?.pathname,
        channelInfo?.cmnCdNm,
        `${deviceId}, ${deviceName}, ${appVersion}`,
        payload?.error?.toString(),
        payload?.error?.stack,
      ]
        .map(item => item || '')
        .join(' / ');
      yield call(api.createErrLog, {
        payload: {
          agentNumber,
          clientId,
          errDescription,
        },
      });
    }
  } catch (error) {
    console.log('createErrLog() - error', error);
  }
}

// showExceptionModal 에러 처리
function* showExceptionModal({ payload }) {
  yield createErrLog({ payload: { error: payload } });
}

// 상벌점에 따라 가입설계 설계목록 막기
function* checkRdopCont({ payload }) {
  const empNo = payload.userInfo.userId;
  const { status, data } = yield call(api.checkRdopCont, {
    payload: { stafCd: empNo },
  });
  if (status === 200) {
    yield put({
      type: actions.CHECK_RDOP_CONT_SUCCESS,
      payload: data,
    });
  }
}

// 사전심사 고도화 (PRE-UW) ================>

function getQuwRsltCodeInfo(losCodeInfo) {
  const QUW_RLST_INFO = {
    10: {
      label: '가능',
      styleClass: 'under-review',
      labelClass: 'green',
    },
    20: {
      label: '조건부',
      styleClass: 'complete',
      labelClass: 'blue',
    },
    30: {
      label: '고지',
      styleClass: 'receipt',
      labelClass: 'yellow',
    },
    40: {
      label: '불가',
      styleClass: 'return',
      labelClass: 'red',
    },
  };

  return losCodeInfo.map(({ cdVal, cdNm }) => ({
    quwRsltCd: cdVal,
    quwRsltNm: cdNm,
    ...QUW_RLST_INFO[cdVal],
  }));
}

/**
 * LOS 공통 코드 조회
 * @param {object} actions
 * @param {object} actions.payload
 * @param {string} actions.payload.cmnCdList 콤마(,) 구분자
 * @example { cmnCdList : 'QUW_RSLT_CD,KMNGR_MRTGG_CLSS_CD' }
 */
function* getLosCodeInfo({ payload }) {
  const { cmnCdList } = payload;
  const response = yield call(api.getLosCodeInfo, {
    payload: {
      cmnCdList,
    },
  });

  if (checkApiSuccess(response)) {
    const data = getApiData(response);
    const losCodeInfo = Object.keys(data).reduce((acc, id) => {
      let losCodeInfo;
      if (id === LOS_COMMON_CODE_INFO.QUW_RSLT_CD) {
        losCodeInfo = getQuwRsltCodeInfo(data[id]);
      } else {
        losCodeInfo = data[id].map(({ cdNm: label, cdVal: value }) => ({
          label,
          value,
        }));
      }

      return {
        ...acc,
        [id]: losCodeInfo,
      };
    }, {});

    yield put(actions.setLosCodeInfo(losCodeInfo));
  } else {
    yield put(
      actions.showAlert({
        message: getApiErrorMessage(response),
      }),
    );
  }
}

function* getDiseaseList({ payload }) {
  const { callback } = payload;

  const response = yield call(api.retrieveDiseaseList);

  if (checkApiSuccess(response)) {
    if (isFunction(callback)) {
      callback(getApiData(response));
    }
  } else {
    const errorMessage = getApiErrorMessage(response);
    yield put(
      showAlert({
        message: fp.isArray(errorMessage)
          ? errorMessage.join('\n')
          : errorMessage,
        wide: Array.isArray(errorMessage),
      }),
    );
  }
}

function* getDiseaseInfo({ payload }) {
  const { params, callback } = payload;

  const response = yield call(api.retrieveDiseaseInfo, {
    params,
  });

  if (checkApiSuccess(response)) {
    if (isFunction(callback)) {
      callback(getApiData(response));
    }
  } else {
    const errorMessage = getApiErrorMessage(response);
    yield put(
      showAlert({
        message: fp.isArray(errorMessage)
          ? errorMessage.join('\n')
          : errorMessage,
        wide: Array.isArray(errorMessage),
      }),
    );
  }
}

// watcher
function* watchCommon() {
  yield takeEvery(actions.CONFIRM_MODAL, confirmModal);
  yield takeEvery(actions.CANCEL_MODAL, cancelModal);
  yield takeEvery(
    actions.SHOW_JOIN_AGREE_BOTTOM_SHADOW,
    showJoinAgreeBottomShadowProc,
  );

  // 직업, 운전 정보 검색
  yield takeEvery(actions.SEARCH_JOB_DRIVER_INFO, searchJobNDriverInfo);
  yield takeEvery(actions.SEARCH_BOOKMARK_JOB_INFO, searchBookMarkJobInfo);
  yield takeEvery(actions.SEARCH_JOB_INFO, searchJobInfo);

  yield takeEvery(actions.GET_EDU_GA_SMS, getEduGASms);
  yield takeEvery(actions.SAVE_FINANCE_CUSTOMER_INFO, saveFinanceCustomerInfo);

  // 공통 코드 세팅
  yield takeEvery(actions.FETCH_CODE_INFO, setCodeInfo);

  //본부, 지점 검색
  yield takeEvery(actions.GET_HQ_LIST_BY_CHANNEL, getHqListByChannel);
  yield takeEvery(actions.GET_AGENCY_LIST_BY_HQ, getAgencyListByHq);

  // 화면 에러 서버로 전송
  yield takeEvery(actions.CREATE_ERR_LOG, createErrLog);

  // showExceptionModal 에러 처리
  yield takeEvery(actions.SHOW_EXCEPTION_MODAL, showExceptionModal);

  // 상벌점에 따라 가입설계 설계목록 막기
  yield takeEvery(actions.CHECK_RDOP_CONT, checkRdopCont);

  yield takeEvery(actions.GET_LOS_CODE_INFO, getLosCodeInfo);

  yield takeEvery(actions.GET_DISEASE_LIST, getDiseaseList);
  yield takeEvery(actions.GET_DISEASE_INFO, getDiseaseInfo);
}

export default function* commonSaga() {
  yield all([fork(watchCommon)]);
}
